export default "__VITE_ASSET__D03hIX91__"